import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { MiscModule } from '../../misc/misc.module';
import { LoginPageRoutingModule } from './login-routing.module';
import { LoginPageComponent } from './login.page';

@NgModule({
  declarations: [LoginPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoginPageRoutingModule,
    ReactiveFormsModule,
    MiscModule,
    ErrorMessageDirective
  ]
})
export class LoginPageModule {}
